<template>
  <div class="outlibrary">
    <my-head title="出库管理" :isRightClick="true" />
    <mu-text-field v-model="vin" v-show='isShowVin' placeholder="VINx" ref="vin" class='input' @keyup.enter.native=""><i
        class="iconfont icon-saomiao" @click="scan('showVin')"></i></mu-text-field>
    <mu-text-field v-model="surevin" v-show='isShowSurevin' placeholder="surevin" ref="surevin" class='input'
      @keyup.enter.native="isPickCar()"><i class="iconfont icon-saomiao" @click="scan('sureVin')"></i></mu-text-field>

    <!-- <mu-paper class="paper" :z-depth="2"  > -->
    <mu-text-field v-model="vin" v-show="isShowCardMsg" placeholder="VIN" ref="vin" class='input'
      @keyup.enter.native="userActive(1)"><i class="iconfont icon-saomiao" @click="scan('showVin')"></i></mu-text-field>
    <!-- </mu-paper> -->
    <mu-paper class="paper" :z-depth="2" v-show="isShowCardReceive">
      <div class="list-content">VIN ：<span>{{ vinBefore }}<i class='mark6'>{{ vinAfter }}</i></span></div>
      <div class="list-content">任务类型：{{ infoForm.taskType }}</div>
      <div class="list-content">备注详情：{{ infoForm.remark }}</div>
      <div class="list-content">取车库位：<span class="library-position">{{ infoForm.pickLocation }}</span></div>
    </mu-paper>
    <mu-paper class="paper" :z-depth="2" v-show="isShowCardGetOnCar">
      <div class="list-content">VIN ：<span>{{ vinBefore }}<i class='mark6'>{{ vinAfter }}</i></span></div>
      <div class="list-content">任务类型：<span>{{ infoForm.taskType }}</span></div>
      <div class="list-content">交通车：<span class="library-position">{{ infoForm.bus }}</span></div>
      <div class="list-content">交通车状态：<span class="library-position">{{ infoForm.busStatus }}</span></div>
      <div class="list-content">上车站点：<span>{{ infoForm.busPosition }}</span></div>
      <div class="list-content">取车库位：<span class="library-position">{{ infoForm.pickLocation }}</span></div>
      <div class="list-content">备注详情：{{ infoForm.remark }}</div>
      <div class="list-content">
        <mu-button color="primary" @click="seeMaps">查看地图</mu-button>
      </div>
    </mu-paper>

    <mu-paper class="paper" :z-depth="2" v-show="isShowCardTiaoCar">
      <div class="list-content">VIN ：<span>{{ vinBefore }}<i class='mark6'>{{ vinAfter }}</i></span></div>
      <div class="list-content">车型：<span>{{ infoForm.carType }}</span><em></em>颜色：<span>{{ infoForm.color }}</span></div>
      <div class="list-content">配置：<span>{{ infoForm.config }}</span></div>
      <div class="list-content">任务类型：<span class="library-position">{{ infoForm.taskType }}</span></div>
      <div class="list-content">取车库位：<span class="library-position">{{ infoForm.pickLocation }}</span></div>
      <div class="list-content">目标库位：<mu-text-field v-model="infoForm.targetLocation" placeholder="VIN" ref="vin"
          class='library-position'></mu-text-field></div>
      <div class="list-content">备注详情：{{ infoForm.remark }}</div>
    </mu-paper>

    <div class="btn">
      <mu-button large color="primary" @click="taskCancelQueryRecord">出库记录</mu-button>
    </div>

    <div class="btn">
      <mu-button large v-show="done" color="primary" @click="goBackTask">回退任务</mu-button>
    </div>

    <div class="btn">
      <mu-button large v-show="refuse" color="primary" @click="openBottomSheet()">拒绝任务</mu-button>
      <mu-button large v-show="receive" color="primary" @click="userActive(1)">领取任务</mu-button>
      <mu-button large v-show="cancel" color="primary" @click="isGetOnCar(0)">取消乘车</mu-button>
      <mu-button large v-show="getOn" color="primary" @click="isGetOnCar(1)">上车确认</mu-button>
      <!-- <mu-button large v-show="abnormal" color="primary" @click="goAbnormal">异常上报</mu-button> -->
      <mu-button large v-show="pickCar" color="primary" @click="isPickCar()">取车确认</mu-button>
      <mu-button large v-show="done" color="primary" @click="isTaskDone()">确认完成</mu-button>
      <mu-button large v-show="fixDone" color="primary" @click="taskDone(1)">维修完成</mu-button>
      <mu-button large v-show="carStay" color="primary" @click="taskDone(2)">留车维修</mu-button>
    </div>

    <mu-bottom-sheet :open.sync="openRefuseReasons">
      <mu-list @item-click="closeBottomSheet">
        <mu-sub-header>请拒绝原因</mu-sub-header>
        <mu-list-item button v-for="(item, index) in refuseReasons" :key="index" @click="userActive(0, item.reason)">
          <mu-list-item-title>{{ item.reason }}</mu-list-item-title>
        </mu-list-item>
      </mu-list>
    </mu-bottom-sheet>
    <mu-dialog title="是否确认完成?" width="600" max-width="80%" :esc-press-close="false" :overlay-close="false"
      :open.sync="isuredoneDialog">
      <mu-button slot="actions" flat color="primary" @click="sureDone()">是</mu-button>
      <mu-button slot="actions" flat color="primary" @click="closeThisConfirm">否</mu-button>
    </mu-dialog>
    <!-- <div class="targetLocation" ref="test" @click="watchTest">
        当前库位坐标
        <div>经：{{longitude}}</div>
        <div>纬：{{latitude}}</div>
        <div>半径：{{railRadius}}</div>
        <div>距离：{{lengths}}</div>
    </div> -->
    <scanning v-if="isScanning" :mark="scanMark" v-on:childByValue="childByValue" v-on:closeing="closeing" />
  </div>
</template>

<script>
import myHead from '@/components/header'
import scanning from "@/components/scanning"
import api from "@/common/api"
export default {
  name: 'outlibrary',
  components: {
    myHead, scanning
  },
  data() {
    return {
      scanMark: '',
      isScanning: false,
      iswatchTest: false,
      isuredoneDialog: false,
      surevin: '',
      taskid: null,
      openRefuseReasons: false,
      refuseReasons: [],
      isShowSurevin: false,
      msg: "当前无任务",
      infoForm: {
        taskType: '',
        pickLocation: '',
        busPosition: '',
        bus: '',
        carType: '',
        color: '',
        cmalTrailSeq: '',
        config: '',
        company: '',
        carrier: '',
        transportMode: '',
        targetLocation: '',
        busStatus: '',
        remark: ''
      },
      vin: '',
      vinBefore: '',
      vinAfter: '',
      isShowVin: false,
      isShowCardReceive: false,
      isShowCardGetOnCar: false,
      isShowCardTiaoCar: false,
      isShowCardMsg: false,
      refuse: false,
      receive: false,
      cancel: false,
      getOn: false,
      abnormal: false,
      pickCar: false,
      done: false,
      fixDone: false,
      shows: true,
      carStay: false,
      latitude: 0,
      longitude: 0,
      dlatitude: 0,
      dlongitude: 0,
      railRadius: 10,
      lengths: 0,
      isDisCompute: true,
      requestOnce: true
    }
  },
  methods: {
    taskCancelQueryRecord() {
      this.$router.push({ path: '/brarylist', query: { from: 'outlibrary' } });
    },
    goBackTask() {
      // 回退任务
      console.log("回退任务");
      if (this.requestOnce) {
        this.requestOnce = false;
        let data = Object.assign({}, this.$store.state.user, {
          content: {
            vin: this.vinBefore + this.vinAfter,
            taskid: this.taskid,
            targetLocation: this.infoForm.targetLocation
          }
        });
        this.common.reqData(api.app('outlibraryCancel'), data, res => {
          this.requestOnce = true;
          let datas = res.data;
          if (datas.status == 100) {
            this.Toast({
              duration: 2000,
              mask: true,
              message: '回退成功'
            });
            this.refuse = this.receive = this.cancel = this.getOn = this.abnormal = this.pickCar = this.done = this.fixDone = this.carStay = this.isShowCardReceive = this.isShowCardGetOnCar = this.isShowCardTiaoCar = false;
            this.isShowCardMsg = this.receive = true;
          } else {
            this.Toast({
              duration: 0,
              mask: true,
              message: datas.msg
            });
          }
        }, err => {
          this.requestOnce = true;
          console.log(err)
          this.Toast.clear();
        });
      } else {
        return false;
      }
    },
    closeing(val) {
      val ? this.isScanning = false : null;
    },
    childByValue(val) {
      if (val) {
        if (val.split('&')[1] == 'showVin') {
          this.vin = val.split('&')[0];
          this.userActive(1);
        } else if (val.split('&')[1] == 'sureVin') {
          this.surevin = val.split('&')[0];
          this.isPickCar();
        }
      }
    },
    scan(txt) {
      this.scanMark = txt;
      this.isScanning = true;
    },
    watchTest() {
      if (this.iswatchTest) {
        this.$refs.test.classList.remove('hover')
      } else {
        this.$refs.test.classList.add('hover')
      }
      this.iswatchTest = !this.iswatchTest;
    },
    seeMaps() {
      this.$router.push({
        name: 'maps', params: {
          marks: [{
            latitude: this.dlatitude,
            longitude: this.dlongitude,
            name: "出库交通车",
            phone: "出库交通车"
          }],
          flag: 0
        }
      });
    },
    isTaskDone() {
      // 确认完成
      this.isuredoneDialog = true;
      // this.disCompute("MANUAL", ()=>{
      //     // 在电子围栏半径内
      //     this.isuredoneDialog = true;
      // });
    },
    sureDone() {
      this.taskDone(0, 'MANUAL');
      this.isuredoneDialog = false;
    },
    closeThisConfirm() {
      this.isuredoneDialog = false;
    },
    /* 任务完成 */
    taskDone(flag, manual) {
      if (this.requestOnce) {
        this.requestOnce = false;
        let data = Object.assign({}, this.$store.state.user, {
          content: {
            vin: this.vinBefore + this.vinAfter,
            flag: flag,
            action: manual ? manual : -1,
            targetLocation: this.infoForm.targetLocation
          }
        });
        this.common.reqData(api.app('outlibraryDone'), data, res => {
          this.requestOnce = true;
          let datas = res.data;
          if (datas.status == 100) {
            if (flag == 0) {
              this.Toast.success({
                duration: 1500,
                mask: true,
                message: "已确认完成"
              });
              this.abnormal = this.done = false;
              manual == "RAIL" ? this.common.tts("任务已自动完成") : 0;
              this.longitude = this.latitude = 0;
              this.isDisCompute = false;
              this.vin = "";
              this.oneResdata(this.$store.state.user);
            } else if (flag == 1) {
              this.Toast.success({
                duration: 1500,
                mask: true,
                message: "已维修"
              });
              this.fixDone = this.carStay = false;
              setTimeout(() => {
                this.$router.push({ name: 'transposing' });
              }, 1200);
            } else {
              this.Toast.success({
                duration: 1500,
                mask: true,
                message: "已留车"
              });
              this.fixDone = this.carStay = false;
            }
          } else {
            this.Toast({
              duration: 0,
              mask: true,
              message: datas.msg
            });
          }
        }, err => {
          this.requestOnce = true;
          console.log(err)
          this.Toast.clear();
        });
      } else {
        return false;
      }
    },
    /* 取车 */
    isPickCar() {
      let data = null;
      let myvin = this.vinBefore + this.vinAfter;
      if (this.surevin == '') {
        data = Object.assign({}, this.$store.state.user, {
          content: {
            vin: myvin,
            issurevin: false
          }
        });
      } else {
        if (this.surevin == myvin) {
          data = Object.assign({}, this.$store.state.user, {
            content: {
              vin: myvin,
              issurevin: true
            }
          });
        } else {
          this.Toast({
            duration: 2000,
            mask: true,
            message: "VIN验证错误"
          });
          return false;
        }
      }
      if (this.requestOnce) {
        this.requestOnce = false;
        this.common.reqData(api.app('isPickCar'), data, res => {
          this.requestOnce = true;
          let datas = res.data;
          if (datas.status == 100) {
            console.log('flag', datas.content.flag);
            if (datas.content.flag == 0) {
              // 待完成
              this.isShowSurevin = false;
              this.isShowVin = false;
              this.refuse = false, this.receive = false, this.cancel = false, this.getOn = false, this.abnormal = true, this.pickCar = false, this.done = true, this.fixDone = false, this.carStay = false;
            } else {
              // 待维修
              this.isShowSurevin = false;
              this.isShowVin = false;
              this.refuse = false, this.receive = false, this.cancel = false, this.getOn = false, this.abnormal = true, this.pickCar = false, this.done = false, this.fixDone = true, this.carStay = true;
            }
          } else {
            this.Toast.fail({
              duration: 1000,
              mask: true,
              message: data.msg
            });
          }
        }, err => {
          this.requestOnce = true
          console.log(err)
          this.Toast.clear();
        });
      }
    },
    /* 上车确认 */
    isGetOnCar(flag) {
      let data = Object.assign({}, this.$store.state.user, {
        content: {
          flag: flag
        }
      });
      if (this.requestOnce) {
        this.requestOnce = false;
        this.common.reqData(api.app('busUpdate'), data, res => {
          console.log(res.data);
          this.requestOnce = true;
          if (res.data.status == 100) {
            if (flag == 0) {
              this.Toast.success({
                duration: 1000,
                mask: true,
                message: '已取消乘车'
              });
            } else {
              this.Toast.success({
                duration: 1000,
                mask: true,
                message: '已上车'
              });
            }
            this.oneResdata(data);
          } else {
            this.Toast({
              duration: 1000,
              mask: true,
              message: res.data.msg
            });
            this.requestOnce = true
          }
        }, err => {
          console.log(err)
        });
      }
    },
    /* 异常跳转 */
    goAbnormal() {
      this.$router.push({ name: "abnormal", params: { vin: this.vinBefore + this.vinAfter } });
    },
    /* 关闭选项 */
    closeBottomSheet() {
      this.openRefuseReasons = false;
    },
    /* 打开选项 */
    openBottomSheet() {
      this.openRefuseReasons = true;
    },
    /* 用户动作 领取 拒绝任务*/
    userActive(flag, reason) {
      let data = Object.assign({}, this.$store.state.user, {
        content: {
          vin: this.vin,
          flag: flag
        }
      });
      if (flag == 0) {
        data = Object.assign({}, this.$store.state.user, {
          content: {
            vin: this.vin,
            flag: flag,
            reason: reason
          }
        });
      }
      if (this.requestOnce) {
        this.requestOnce = false;
        this.common.reqData(api.app('taskOutWarehousePickup'), data, res => {
          this.requestOnce = true;
          let datas = res.data;
          console.log(datas);
          if (datas.status == 100) {
            if (flag == 0) {
              this.Toast.success({
                duration: 1000,
                mask: true,
                message: "已拒绝任务"
              });
              this.isShowCardMsg = true;
              this.msg = "拒绝任务，已暂停接单!", this.isShowCardReceive = false, this.refuse = false, this.receive = false;
            } else {
              this.Toast.success({
                duration: 1000,
                mask: true,
                message: "已领取任务"
              });
              this.oneResdata(data);
            }
          } else {
            this.Toast.fail({
              duration: 1000,
              mask: true,
              message: datas.msg
            });
          }
        }, err => {
          this.requestOnce = true
          console.log(err)
          this.Toast.clear();
        });
      }
    },
    /* 进入页面的第一次查询 */
    oneResdata(data) {
      let data_base = data;
      this.common.reqData(api.app('outlibrary'), data, res => {
        console.log("第一次查询", res);
        let data = res.data;
        if (data.status == 100) {
          if (!data.content) {
            this.isShowCardReceive = false,
              this.isShowCardGetOnCar = false,
              this.isShowCardTiaoCar = false,
              this.isShowCardMsg = true;
            this.isShowVin = false;
            this.isShowSurevin = false;
            this.receive = true;
            // 如果没有任务
            console.log("待办进入", this.$route.query.code, data_base);
            if (this.$route.query.code) {
              this.vin = this.$route.query.code;
              this.userActive(1);
            }
          } else {
            // 如果有任务
            console.log("待办进入", this.$route.query.code);
            this.Toast({
              mask: true,
              message: "当前有未完成的任务。"
            });
            this.taskid = res.data.content.taskid || null;
            if (data.content.flag == 0) {
              // 待领取
              this.isShowVin = false;
              this.isShowCardReceive = true,
                this.isShowCardGetOnCar = false,
                this.isShowCardTiaoCar = false,
                this.isShowCardMsg = false;
              this.isShowSurevin = false;
              this.vin = data.content.vin;
              this.stringVinSplit(data.content.vin);
              this.infoForm.taskType = data.content.taskType;
              this.infoForm.pickLocation = data.content.pickLocation;
              this.infoForm.remark = data.content.remark;
              this.latitude = data.content.latitude;
              this.longitude = data.content.longitude;
              this.railRadius = data.content.railRadius;
              this.dlatitude = data.content.dlatitude;
              this.dlongitude = data.content.dlongitude;
              this.refuse = true, this.receive = true, this.cancel = false, this.getOn = false, this.abnormal = false, this.pickCar = false, this.done = false, this.fixDone = false, this.carStay = false;
            } else if (data.content.flag == 1) {
              // 待上车
              this.isShowSurevin = false;
              this.isShowVin = false;
              this.isShowCardReceive = false,
                this.isShowCardGetOnCar = true,
                this.isShowCardTiaoCar = false,
                this.isShowCardMsg = false;
              this.vin = data.content.vin;
              this.stringVinSplit(data.content.vin);
              this.infoForm.taskType = data.content.taskType;
              this.infoForm.pickLocation = data.content.pickLocation;
              this.infoForm.bus = data.content.busNo;
              this.infoForm.busPosition = data.content.boradPoint;
              this.infoForm.busStatus = data.content.busStatus;
              this.infoForm.remark = data.content.remark;
              this.latitude = data.content.latitude;
              this.longitude = data.content.longitude;
              this.dlatitude = data.content.dlatitude;
              this.dlongitude = data.content.dlongitude;
              this.railRadius = data.content.railRadius;
              this.refuse = false, this.receive = false, this.cancel = true, this.getOn = true, this.abnormal = false, this.pickCar = false, this.done = false, this.fixDone = false, this.carStay = false;
              if (this.infoForm.bus == "" || !data.content.busNo) {
                this.getOn = false;
              }
            } else {
              (data.content.show == 0) ? this.shows = false : this.shows = true;
              this.isShowCardReceive = false,
                this.isShowCardGetOnCar = false,
                this.isShowCardTiaoCar = true,
                this.isShowCardMsg = false;
              this.isShowSurevin = false;
              this.stringVinSplit(data.content.vin);
              this.infoForm.taskType = data.content.taskType;
              this.infoForm.pickLocation = data.content.pickLocation;
              this.infoForm.carType = data.content.vehicleType;
              this.infoForm.color = data.content.color;
              this.infoForm.cmalTrailSeq = data.content.cmalTrailSeq;
              this.infoForm.config = data.content.config;
              this.infoForm.company = data.content.company;
              this.infoForm.carrier = data.content.carrier;
              this.infoForm.transportMode = data.content.transportMode;
              this.infoForm.targetLocation = data.content.targetLocation;
              this.infoForm.remark = data.content.remark;
              this.latitude = data.content.latitude;
              this.longitude = data.content.longitude;
              this.railRadius = data.content.railRadius;
              this.dlatitude = data.content.dlatitude;
              this.dlongitude = data.content.dlongitude;
              if (data.content.flag == 2) {
                // 待取车
                this.isShowSurevin = true;
                setTimeout(() => {
                  this.$refs.surevin.$el.children[0].getElementsByTagName('input')[0].focus();
                  window.plus ? plus.key.hideSoftKeybord() : 0;
                }, 50);
                this.isShowVin = false;
                this.refuse = false, this.receive = false, this.cancel = false, this.getOn = false, this.abnormal = true, this.pickCar = true, this.done = false, this.fixDone = false, this.carStay = false;
              } else if (data.content.flag == 3) {
                // 待维修
                this.isShowVin = false;
                this.isShowSurevin = false;
                this.refuse = false, this.receive = false, this.cancel = false, this.getOn = false, this.abnormal = true, this.pickCar = false, this.done = false, this.fixDone = true, this.carStay = true;
              } else if (data.content.flag == 4) {
                // 待完成
                this.isShowVin = false;
                this.isShowSurevin = false;
                this.refuse = false, this.receive = false, this.cancel = false, this.getOn = false, this.abnormal = true, this.pickCar = false, this.done = true, this.fixDone = false, this.carStay = false;
              }
            }
          }
        } else {
          this.Toast({
            mask: true,
            message: res.data.msg
          });
        }
      }, err => {
        console.log(err)
        this.Toast.clear();
      });
    },
    /* 字符串切割 */
    stringVinSplit(str) {
      let a = str.length - 6,
        b = str.length;
      this.vinBefore = str.substring(0, a);
      this.vinAfter = str.substring(a, b);
    },
    disCompute(manual, func) {
      console.log('定位或速度已经改变' + this.$store.state.latitude + "-" + this.$store.state.longitude + "-" + this.latitude + "-" + this.longitude)
      if (this.isDisCompute) {
        this.common.distanceCompute({
          latitude: this.latitude,
          longitude: this.longitude
        }, {
          latitude: this.$store.state.latitude,
          longitude: this.$store.state.longitude
        }, this.railRadius, () => {
          this.taskDone(0, manual)
        }, func);
        // 测试用距离计算
        let _this = this;
        let selfPoint = new plus.maps.Point(this.longitude, this.latitude)
        let targetPoint = new plus.maps.Point(this.$store.state.longitude, this.$store.state.latitude)
        plus.maps.Map.calculateDistance(targetPoint, selfPoint, function (event) {
          var distance = event.distance // 转换后的距离值
          _this.lengths = distance
        }, function (e) {
          console.log('Failed:' + JSON.stringify(e))
        })
      }
    }
  },
  mounted() {
    let data = null;
    if (this.$route.params.vin) {
      // 其他进入
      data = Object.assign({}, this.$store.state.user, {
        content: {
          vin: this.$route.params.vin
        }
      });
    } else {
      data = this.$store.state.user;
    }
    this.oneResdata(data);
    // 拒绝原因
    this.refuseReasons = this.$store.state.refuseReasons;
  },
  computed: {
    latitudeChange() {
      return this.$store.state.latitude;
    },
    longitudeChange() {
      return this.$store.state.longitude;
    },
    speedChange() {
      return this.$store.state.speed;
    }
  },
  watch: {
    latitudeChange: function (data) {
      this.disCompute("RAIL");
    },
    longitudeChange: function (data) {
      this.disCompute("RAIL");
    },
    speedChange: function (data) {
      this.disCompute("RAIL");
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.outlibrary {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.btn {
  /* position: absolute;
  bottom: 20px;
  left: 0;
  right: 0; */
  margin: 20px 0 0;
  display: flex;
  justify-content: space-around;
}

.btn .mu-raised-button {
  font-size: 18px;
  height: 40px;
  line-height: 40px;
}

.input {
  display: block;
  margin: 15px auto;
  width: 85%;
}

.paper,
.state,
.msg {
  width: 85%;
  margin: 1em auto 0;
  padding: 1.5em 0;
}

.list-content {
  padding: 5px 20px;
}

.library-position {
  font-size: 1.5em;
  font-weight: bold;
  color: red;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
}

em {
  padding: 0 10px;
}

.mark6 {
  font-style: normal;
  color: red;
  font-size: 1.25em;
}
</style>



// WEBPACK FOOTER //
// src/components/inoutlibrary/outlibrary.vue